/**
 * Used across the application to identify current MarketCode context
 */

export const DomainMarketCode = Object.freeze({
  CELLCOM: 'CLC',
  GOLAN: 'GLN',
});

/**
 * Hostname patterns for brand detection
 */
export const MarketCodeHostnames = Object.freeze({
  
  CELLCOM: 'cellcom.co.il',
  GOLAN: 'golantelecom.co.il',
});

/**
 * Get MarketCode code from hostname
 * @param {string} hostname - window.location.hostname
 * @returns {string} MarketCode code ('CLC' or 'GLN')
 */

export const getMarketCode = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('golan')) {
    return DomainMarketCode.GOLAN;
  }  return DomainMarketCode.CELLCOM;
};